export const filterRoutes = (routes, hiddenRoutes) => {
  return routes
    .filter((route) => !hiddenRoutes.includes(route.name))
    .map((route) => {
      if (!route.children) {
        return route;
      }

      return {
        ...route,
        children: filterRoutes(route.children, hiddenRoutes),
      };
    });
};
